<h2>Adjust Dwolla Balance</h2>
<form [formGroup]="form" class="form">
  <mat-form-field appearance="outline">
    <mat-label>Adjustment Amount $</mat-label>
    <input matInput placeholder="0.00" formControlName="amount">
  </mat-form-field>

  <mat-checkbox formControlName="adjustLedger">
    Adjust ledger balance shown in the app
  </mat-checkbox>

  <div class="actions">
    <button mat-stroked-button color="primary" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid || saving" (click)="add()">Add (Credit)</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid || saving" (click)="subtract()">Subtract (Debit)</button>
  </div>
</form>
